<template>
    <div>
      <div class="container">
        <el-dialog
            title="Download Data as CSV"
            :visible.sync="show_download">
          <p style="color:red">Warning!</p>
          <p style="background-color:#eee;padding:5px;">
            One of the primary reasons to use Content Chimera is to avoid spreadsheet plumbing
            in tools like Microsoft Excel and Google Sheets.
          </p>
          <p>If your purpose is to capture this data for archival reasons, then please continue.</p>
          <p><span style="color:red">If the reason to download a CSV is further manipulation in a spreadsheet or other tool,
            then you may wish to reconsider.</span> In general there are many advantages of doing this in
            Content Chimera:
          </p>
          <ul>
            <li>Using rules and mappings, you can modify values automatically across the entire digital presence</li>
            <li>Multiple people can be working in the tool at once</li>
            <li>You can leverage other metadata from other tools that's already been imported and can continue to merge/import more data as well.</li>
          </ul>
          <el-button @click="initiate_download" type="danger">Send CSV of this data via email</el-button>
        </el-dialog>
        <div class="row">
          <div class="col-md-12 ">
        <div style="margin-bottom:20px;padding-left:20px;">
            <span id="table_toggles" style="margin-right:20px;">
                <el-switch v-model="hide_classified">
                </el-switch>
                Only show unclassified
            </span>
            <span style="margin-right:20px;">
                <el-switch v-model="full_width">
                </el-switch>
                Full width
            </span>
            <span style="margin-right:20px;">
                <span v-if="primary_order"> Order by <strong>{{primary_order}}</strong> {{primary_order_dir}}, then </span>
                <span v-if="!order_random"><strong>import</strong> order</span>
                <span v-else>import order</span>
                <el-switch v-model="order_random">
                </el-switch>
                <span v-if="order_random"><strong>random</strong> order</span>
                <span v-else>random order</span>
            </span>
          <span v-if="order_random" style="margin-right:20px;">
                Random (slower)
                <el-switch v-model="repeatable_random">
                </el-switch>
                "Random" (faster)
            </span>
            <span style="float:right">
              <el-button @click="initiate_download_dialog" size="mini" icon="el-icon-download"></el-button>
            </span>
        </div>
    </div>
        </div>
      </div>
      <div :class="container_class">
        <div class="row">
          <div class="col-md-12 ">
            <table-view
                :tableDefinition="tableDefinition"
                :endPoint="endPoint"
                :extentId="extent_id"
                :colors="colors"
                :colored_prop="colored_prop"
                :additional_filters="additional_filters"
                @sortChange="sortChange"
            >
            </table-view>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AssetTableView",
        props: ['extent_id','colors','colored_prop','fields','asset_filter_id','redraw_count','flattened_table_id','additional_filters'],
        methods: {
          initiate_download_dialog() {
            this.show_download = true
          },
          initiate_download() {
            axios.post('/api/assets/initiate_download/' + this.extent_id, {
              flattened_table_id: this.flattened_table_id,
              asset_filter_id: this.asset_filter_id,
              all_filter_tests: this.all_filter_tests,
              fields: this.fields_for_download,
            }).then(response => {
              console.log(response)

            }).catch(error => {
              console.log('oops initiating download')
              console.log(error.response)
              this.error(error.response.data,"error")
            })
            this.show_download = false
          },
          sortChange(payload) {
            this.primary_order = payload.prop
            this.primary_order_dir = payload.order
          }
        },
        computed: {
            fields_for_download: function() {
              let short_fields = []
              this.tableDefinition.forEach(column => {
                if ( ! ((column.prop === 'row_num') || (column.prop === 'edit_button') || (column.prop === ''))) {
                  short_fields.push(column.prop)
                }
              })
              return short_fields
            },
            container_class: function() {
                if (this.full_width) {
                  return 'container-fluid'
                } else {
                  return 'container'
                }
            },
            endPoint: function () {
              console.log('(In AssetTableView) endPoint computation -- additional_filters:')
              console.log(this.additional_filters)
                if (this.extent_id) {
                    let url='/migration/assets/' + this.extent_id + '?'
                    url = url + 'only_unclassified='
                    if (this.hide_classified) {
                        url = url + 'true'
                    } else {
                        url = url + 'false'
                    }
                    url = url + '&order='
                    if (this.order_random) {
                        url = url + 'random'
                    } else {
                        url = url + 'import'
                    }
                    if (this.primary_order) {
                      url = url + '&primary_order=' + this.primary_order
                    }
                    if (this.primary_order_dir) {
                      url = url + '&primary_order_dir=' + this.primary_order_dir
                    }
                  url = url + '&repeatable_random='
                  if (this.repeatable_random) {
                    url = url + 'true'
                  } else {
                    url = url + 'false'
                  }
                  if (this.flattened_table_id) {
                    url = url + '&flattened_table_id=' + this.flattened_table_id
                  }
                  if (this.asset_filter_id) {
                    url = url + '&asset_filter_id=' + this.asset_filter_id
                  }
                  url = url + '&version='
                  url = url + this.redraw_count
                  return url
                } else {
                    return null
                }
            },
          tableDefinition: function() {
              let def = [
                {
                  'prop': 'row_num',
                  'label': '',
                  'type': 'integer',
                  'width': '30'
                },
                {
                  'prop': 'address_normalized',
                  'label': 'Normalized Address',
                  'type': 'url',
                  'width': '400'
                },
              ];
              if (this.flattened_table_id) {
                def.push({
                  'prop': 'raw_value',
                  'label': 'Raw Value',
                  'type': 'string',
                  'width': '370'
                })
              } else {
                def.push({
                      'prop': 'title',
                      'label': 'Title',
                      'type': 'string',
                      'width': '370'
                })
              }
              if (this.fields) {
                this.fields.forEach(field => {
                  def.push({
                    'prop': field,
                    'label': field,
                    'type': 'string',
                    'width': '120'
                  })
                })
              }
              return def
          }
        },
        data() {
            return {
                hide_classified: false,
                order_random: false,
                repeatable_random: true,
                full_width: false,
                show_download: false,
                primary_order: null,
                primary_order_dir: 'asc',
            }
        },
    }
</script>

<style scoped>

</style>